// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonCard_container__W3wUM","content":"PersonCard_content__V09Yw","name":"PersonCard_name__FqV_2","titles":"PersonCard_titles__GXX2X"};